import React from 'react'
import ReCAPTCHA from 'react-google-recaptcha'

import { getKeyRecaptchaUrl } from 'utils/endpoints'

const secretKey = getKeyRecaptchaUrl() || ''

type Props = {
  captchaRef: any
  onChange?: (value: string | null) => void
}

const ReCaptcha = (props: Props) => {
  const { captchaRef } = props

  return (
    <ReCAPTCHA
      ref={captchaRef}
      sitekey={String(secretKey)}
      onChange={(value) => props.onChange && props.onChange(value)}
    />
  )
}

export default ReCaptcha
